var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation'),_c('form',{staticClass:"ui form",on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('create-form',{ref:"createForm",attrs:{"company-models":_vm.companyModels,"country-models":_vm.countryModels},on:{"cancel":_vm.cancel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }